import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom'
import { TextLink, TextLinkProps } from '@hawkins/components';
import { Colors } from '@hawkins/variables';

import { TranslationNamespace } from '../types';
import { useLocaleIcons } from '../hooks/useLocaleIcons';

export interface BackButtonProps extends TextLinkProps {
  path?: string;
  text?: string;
}

export function BackButton({ text, path }: BackButtonProps) {
  const { t } = useTranslation(TranslationNamespace.LEP);
  const { IconArrowLeft } = useLocaleIcons();
  const navigate = useNavigate();

  if (!text) {
    text = t('common_back');
  }

  return (
    <TextLink
      onClick={() => {
        path ? navigate(path) : navigate(-1);
      }}
      style={{ color: Colors.Black, textDecoration: 'none' }}
      variant="standalone"
    >
      <IconArrowLeft />
      {text}
    </TextLink>
  );
}
